import { render, staticRenderFns } from "./consultationNewShow.vue?vue&type=template&id=23066254"
import script from "./consultationNewShow.vue?vue&type=script&lang=js"
export * from "./consultationNewShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports